module.exports = __webpack_public_path__ + "app/assets/images/man5-d1ecb6ea8ce88f41de1adcfedf408c5e.jpg";